import { ALL } from '@/model/rating/recommendations'

export default {
    alternative: 'There are no macro-trends in this section',

    title: 'Macro-trends in this section',

    info: 'What does {recommendation} mean?',

    [ALL]: {
        title: 'All',
        section: 'Macro-trends in the section {title}'
    }
}
